<template>
  <div>
    <div class="desktop" style="margin-top: 67px; padding-left: 30px; padding-right: 30px;">
      <div class="freetrial-head-title">
        <h1>{{freetrials}}명이 선택한 무료체험</h1>
      </div>
      <section class="freetrial-hero">
        <div class="title">
          <h1>택배비조차 저희가 부담해요</h1>
          <p>
            <span class="bold">30일간 무료</span>로 얼마든지 써보고
            <br>맘에 들지 않으면
            <span class="bold">우체국 기사님이 수거하러 찾아갈게요.</span>
            <br>걱정마세요
            <span class="bold">제품이 부셔져도 반납은 무조건 무료</span>입니다.
          </p>
        </div>
      </section>
      <section class="freetrial-return">
        <div class="title">
          <h1>너무나 쉽고 빠른 무료 반품하기</h1>
        </div>
        <div class="freetrial-description-wrapper">
          <div>
            <div class="freetrial-description-container">
              <img style="width: 220px;" src="@/assets/free-trial/return-step1.png" alt>
              <div class="right-descrition">
                <h2>STEP 1</h2>
                <p>앱에서 반납하기 버튼을 누르고</p>
              </div>
            </div>
          </div>
          <div
            style="width: 1021px; height: 2px; background-color: #dee2e5; margin:45px auto; margin-top: 0;"
          ></div>
          <div>
            <div class="freetrial-description-container">
              <img style="width: 220px;" src="@/assets/free-trial/return-step2.png" alt>
              <div class="right-descrition">
                <h2>STEP 2</h2>
                <p>원하는 방문 수거 날짜를 선택</p>
              </div>
            </div>
          </div>
          <div
            style="width: 1021px; height: 2px; background-color: #dee2e5; margin:45px auto; margin-top: 0;"
          ></div>
          <div>
            <div class="freetrial-description-container">
              <img style="width: 200px;" src="@/assets/free-trial/return-step3.png" alt>
              <div class="right-descrition">
                <h2>STEP 3</h2>
                <p>우체국 집배원에게 제품을 전달하면 완료</p>
                <p style="font-size: 14px;">*반품 포장 시 아이오 전용 패키지가 아니어도 괜찮습니다.</p>
              </div>
            </div>
          </div>
          <div
            style="width: 1021px; height: 2px; background-color: #dee2e5; margin:45px auto; margin-top: 0;"
          ></div>
        </div>
      </section>
      <section class="freetrial-description">
        <div class="title">
          <h1>한 달 무료체험 신청 방법</h1>
        </div>
        <div class="freetrial-description-wrapper">
          <div>
            <div class="freetrial-description-container">
              <img style="width: 249px;" src="@/assets/free-trial/step1.png" alt>
              <div class="right-descrition">
                <h2>STEP 1</h2>
                <p>체험하고 싶은 제품을 장바구니에 담고</p>
              </div>
            </div>
          </div>
          <div style="width: 1021px; height: 2px; background-color: #dee2e5; margin:45px auto;"></div>
          <div>
            <div class="freetrial-description-container">
              <img style="width: 249px;" src="@/assets/free-trial/step2.png" alt>
              <div class="right-descrition">
                <h2>STEP 2</h2>
                <p>배송지 정보를 입력</p>
                <!-- <p style="font-size: 14px;">*무료체험 한 달 후 결제되며, 결제일 전 알림 문자가 미리 전송됩니다.</p> -->
              </div>
            </div>
          </div>
          <div style="width: 1021px; height: 2px; background-color: #dee2e5; margin:45px auto;"></div>
          <div>
            <div class="freetrial-description-container">
              <img style="width: 204px;" src="@/assets/free-trial/step3.png" alt>
              <div class="right-descrition">
                <h2>STEP 3</h2>
                <p>정보 입력이 끝나고 무료 체험 기간을 확인하면 끝</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="freetrial-suggestion">
        <div class="title">
          <h1>자, 어떤 제품을 체험해볼까요?</h1>
        </div>
        <div class="suggestion-wrapper">
          <div class="switcher">
            <h2>Switcher</h2>
            <span>누워서 불을 끄는 가장 심플한 방법</span>
            <button @click="goProduct(1)">제품보기</button>
          </div>
        </div>
        <div class="suggestion-wrapper">
          <div class="linker">
            <h2>Linker</h2>
            <span>우리 집 만능리모컨</span>
            <button @click="goProduct(3)">제품보기</button>
          </div>
        </div>
      </section>
    </div>
    <div class="mobile" style="margin-top: 63px;">
      <section class="freetrial-first">
        <h1>{{freetrials}}명이 선택한 무료체험</h1>
        <div>
          <span>택배비조차 저희가 부담해요</span>
          <p>
            <span class="bold">30일간 무료</span>로 얼마든지 써보고
            <br>맘에 들지 않으면
            <span class="bold">우체국 기사님이 수거하러 찾아갈게요.</span>
            <br>걱정마세요
            <span class="bold">제품이 부셔져도 반납은 무조건 무료</span>입니다.
          </p>
        </div>
      </section>
      <section class="m-freetrial-return">
        <h1>너무나 쉽고 빠른 무료 반품하기</h1>
        <div class="freetrial-instruction-container">
          <div class="instruction-text">
            <p>STEP 1</p>
            <span>앱에서 반납하기 버튼을 누르고</span>
          </div>
          <img style="width: 205px;" src="@/assets/free-trial/return-step1.png" alt>
        </div>
        <div class="freetrial-instruction-container">
          <div class="instruction-text">
            <p>STEP 2</p>
            <span>원하는 방문 수거 날짜를 선택</span>
          </div>
          <img style="width: 205px;" src="@/assets/free-trial/return-step2.png" alt>
        </div>
        <div class="freetrial-instruction-container">
          <div class="instruction-text">
            <p>STEP 3</p>
            <span>
              우체국 집배원에게 제품을 전달하면 완료
              <br>*반품 포장 시 아이오 전용 패키지가
              <br>아니어도 괜찮습니다.
            </span>
          </div>
          <img style="width: 200px;" src="@/assets/free-trial/return-step3.png" alt>
        </div>
      </section>
      <section class="freetrial-second">
        <h1>한 달 무료체험 신청 방법</h1>
        <div class="freetrial-instruction-container">
          <div class="instruction-text">
            <p>STEP 1</p>
            <span>체험하고 싶은 제품을 장바구니에 담고</span>
          </div>
          <img style="width: 243px;" src="@/assets/free-trial/step-01.png" alt>
        </div>
        <div class="freetrial-instruction-container">
          <div class="instruction-text">
            <p>STEP 2</p>
            <span>배송지 정보를 입력</span>
            <!-- <p style="margin-top: 10px; font-weight: normal;">
              *제품은 한 달 후 결제되며,
              <br>결제일 전 반납은 무료입니다.
            </p>-->
          </div>
          <img style="width: 243px;" src="@/assets/free-trial/step-2.png" alt>
        </div>
        <div class="freetrial-instruction-container">
          <div class="instruction-text">
            <p>STEP 3</p>
            <span>
              정보 입력이 끝나고
              <br>무료 체험 기간을 확인하면 끝
            </span>
          </div>
          <img style="width: 243px;" src="@/assets/free-trial/step-3.png" alt>
        </div>
      </section>

      <section class="freetrial-third">
        <h1>자, 어떤 제품을 체험해볼까요?</h1>
        <div class="recommend-product" id="switcher" style="margin-top: 22px;">
          <span>Switcher</span>
          <p>
            누워서 불을 끄는
            <br>가장 심플한 방법
          </p>
          <router-link :to="{ name: 'Switcher' }">
            <button>제품보기</button>
          </router-link>
        </div>
        <div class="recommend-product" id="linker">
          <span>Linker</span>
          <p>우리 집 만능리모컨</p>
          <router-link :to="{ name: 'Linker' }">
            <button>제품보기</button>
          </router-link>
        </div>
      </section>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import AppFooter from './AppFooter'
import {IO_PRODUCTS} from '../modules/products.js'
export default {
  name: 'free-trial',
  components: {AppFooter},
  data () {
    return {
      freetrials: ''
    }
  },
  mounted () {
    this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/free-trials/state/')
      .then((result) => {
        this.freetrials = Number(result.data.ON_FREE_TRIAL) + Number(result.data.RETURNED) + Number(result.data.CONVERTED)
      })
  },
  methods: {
    goProduct: function (productId) {
      switch (productId) {
        case IO_PRODUCTS.SWITCHER_ONE_BUTTON:
          this.$router.push({ name: 'Switcher' })
          break
        case IO_PRODUCTS.LINKER:
          this.$router.push({ name: 'Linker' })
          break
      }
    }
  }
}
</script>
<style scoped>

.freetrial-head-title {
  background-color: #ffffff;
  height: 60px;
  text-align: left;
  padding: 20px 0px 0px 0px;
}
.freetrial-hero {
  text-align: left;
  display: flex;
  align-items: center;
}
.freetrial-hero .title {
  margin-left: 10%;
}
.freetrial-hero h1 {
  font-size: 24px;
  font-weight: bold;
}
.freetrial-hero p {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.57;
}
.freetrial-head-title h1 {
  font-size: 20px;
  font-weight: bold;
}
.freetrial-hero {
  background: url("../assets/free-trial/free-trial.png") no-repeat center center;
  background-size: cover;
  min-height: 452px;
}

.freetrial-return .title {
  margin-top: 100px;
  margin-bottom: 100px;
}
.freetrial-return .title h1 {
  font-size: 24px;
}
.freetrial-description-wrapper {
  display: flex;
  flex-direction: column;
}

.freetrial-description .title {
  margin-top: 100px;
  margin-bottom: 100px;
}
.freetrial-description .title h1 {
  font-size: 24px;
}
.freetrial-description-container {
  width: 50%;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
}

.right-descrition {
  width: 50%;
  text-align: left;
}
.right-descrition h2 {
  font-size: 16px;
  font-weight: bold;
}
.right-descrition p {
  font-size: 16px;
  font-weight: 400;
}
.freetrial-suggestion .title {
  margin-top: 100px;
  margin-bottom: 45px;
}
.freetrial-suggestion .title h1{
  font-size: 20px;
}

.suggestion-wrapper {
  margin-top: 10px;
}
.suggestion-wrapper .switcher {
  background: url("../assets/free-trial/suggestion-switcher.png") no-repeat center center;
  background-size: cover;
  min-height: 260px;
  max-width: 1024px;
  margin: 0 auto;
  padding: 67px 0px 0px 105px;
  text-align: left;
}
.suggestion-wrapper .linker {
  background: url("../assets/free-trial/suggestion-linker.png") no-repeat center center;
  background-size: cover;
  min-height: 260px;
  max-width: 1024px;
  margin: 0 auto;
  padding: 67px 0px 0px 105px;
  text-align: left;
  margin-bottom: 120px;
}
.suggestion-wrapper h2 {
  font-size: 20px;
  font-weight: bold;
}
.suggestion-wrapper span {
  display: block;
  font-size: 18px;
}
.suggestion-wrapper button {
  margin-top: 27px;
  width: 94px;
  height: 39px;
  text-decoration: none;
  background-color: transparent;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  color: #3d4953;
  cursor: pointer;
}

.suggestion-wrapper button:hover {
  border: solid 1px #3d4953;
}
/* mobile */
.freetrial-first {
  background: url("../assets/free-trial/m-free-trial.png") no-repeat center center;
  background-size: cover;
  min-height: 469px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}
.freetrial-first h1 {
  font-size: 18px;
  font-weight: bold;
}
.freetrial-first div {
  margin-top: 23px;
}
.freetrial-first span {
  margin-top: 23px;
  /* font-size: 18px; */
}
.freetrial-first p {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.71;
}

.m-freetrial-return {
  text-align: center;
  padding: 30px;
}

.m-freetrial-return h1 {
  font-size: 18px;
  font-weight: bold;
}

.m-freetrial-return :last-child {
  border: 0;
}
.freetrial-second {
  text-align: center;
  padding: 30px;
}
.freetrial-second h1 {
  font-size: 18px;
  font-weight: bold;
}
.freetrial-second :last-child {
  border: 0;
}
.instruction-text {
  text-align: center;
}
.instruction-text p {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}
.instruction-text span {
  font-size: 14px;
}

.freetrial-instruction-container {
  padding: 20px 20px 0px 20px;
  margin-top: 47px;
  border-bottom: solid 1px #dee2e5;
}
.freetrial-instruction-container img {
  margin-top: 28px;
}
.freetrial-third h1 {
  font-size: 18px;
  font-weight: bold;
}
#switcher {
  background: url("../assets/free-trial/freetrial-switcher.png") no-repeat center bottom;
  background-size: cover;
  min-height: 352px;
}
#linker {
  background: url("../assets/free-trial/freetrial-linker.png") no-repeat center center;
  background-size: cover;
  min-height: 352px;
}

.recommend-product {
  text-align: left;
  padding: 47px 0px 0px 28px;
}
.recommend-product span {
  font-size: 16px;
  font-weight: bold;
}
.recommend-product p {
  font-size: 16px;
  line-height: 1.62;
  margin-top: 10px;
}

.recommend-product button {
  width: 94px;
  height: 39px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  background-color: transparent;
  margin-top: 27px;
  color: #3d4953;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/FreeTrial.vue